import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';

interface PageHeaderProps {
  /** An MUI icon element, e.g. `<LibraryBooks fontSize="large" />`. */
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}

/**
 * The hero header shared by the Projects and Blogs pages: an elevated
 * surface with an icon next to an h3 title, followed by descriptive text.
 *
 * Icon and title are laid out with a row `Stack` + `alignItems="center"` so
 * the icon is vertically centered against the title. (Placing an icon inline
 * inside `Typography` aligns it to the text baseline, which makes a large
 * square icon ride up above the text.)
 */
const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, children }) => (
  <Paper elevation={8} sx={{ p: 4, mb: 4 }}>
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
      {icon}
      <Typography variant="h3">{title}</Typography>
    </Stack>
    <Typography variant="body1">{children}</Typography>
  </Paper>
);

export default PageHeader;
